import { Directive, Input, ViewContainerRef } from '@angular/core';

import { ProfileInfo, ViewProfileType } from 'src/app/interfaces/profile.interface';

@Directive({
  selector: '[view-profile]',
})
export class ViewProfileDirective implements ViewProfileType {
  @Input({ required: true }) public fields: ProfileInfo[] = [];

  public constructor(public container: ViewContainerRef) {}
}
